import React from "react";
import RFamily from "../../PicesForPages/Refinancing_family.jpg";
import FreeConsultation from "../Form/FreeConsultation";
import { Link } from "react-router-dom";

function Refinancing() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent refinancingPageTopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={RFamily}
          alt="RFamilyImage"
          className="background-video R_FamilyImage"
        />
        <div className="purchasetopBox refinancingPageTopBox">
          {/* The existing Purchase span */}
          <span>Refinancing</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <span
              className="purchaseBottomLeftContent"
              style={{ color: "red" }}
            >
              Keep in mind that refinancing your current loan could result in
              higher total finance charges over the life of the new loan.
            </span>
            <span className="purchaseBottomLeftContent">
              Refinancing is commonly done to reduce the interest rate. If
              interest rates have declined since you initially financed your
              home, refinancing might be worth considering. Other typical
              reasons to refinance include settling a balloon payment, switching
              from an adjustable-rate loan to a fixed-rate loan, or withdrawing
              equity from your home (cash out). Common purposes for cashing out
              are home renovations, funding education, or consolidating debt.
            </span>
            <span className="purchaseBottomLeftContent">
              An alternative to refinancing for converting your home equity into
              cash is a "home equity" loan. This option is particularly
              beneficial if your existing mortgage has a significantly lower
              interest rate than current rates or if your loan has a prepayment
              penalty.
            </span>

            <span className="purchaseBottomLeftHeader">Advantages:</span>
            <ul className="purchaseBottomLeftUL paperworkBottomLeftUL">
              <li>Lower Your Interest Rate</li>
              <li>Withdraw Equity for Home Renovations</li>
              <li>Combine Multiple Debts</li>
              <li>Decrease Monthly Payments</li>
            </ul>

            <span className="purchaseBottomLeftHeader">
              Requirements for Refinancing:
            </span>
            <ul className="purchaseBottomLeftUL paperworkBottomLeftUL">
              <li>Updated Appraisal and Financial Analysis</li>
              <li>Proof of Assets and Income</li>
              <li>
                <span>Apply Now, View Required Documents</span>
              </li>
            </ul>

            <div className="purchaseBottomLeftButton">
              <Link
                to="https://www.blink.mortgage/app/signup/p/primehomemortgageincorporated/"
                className="purchaseBottomLeftButtonLink"
              >
                APPLY!
              </Link>
            </div>
          </div>
          <FreeConsultation />
        </div>
      </div>
    </div>
  );
}

export default Refinancing;
